import React, { useEffect, useContext } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import LandingAerce from 'ui/pages/external/landingAerce'
import { IntlContext } from 'context/LocaleContext'
import { findMatchingLocale } from '../../libs/i18n'

const HomeAerce = () => {
  const { locale, changeLocale } = useContext(IntlContext)

  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)

    if (queryParams.has('locale')) {
      const newLocale = findMatchingLocale(queryParams.get('locale'))
      if (newLocale && locale !== newLocale) {
        changeLocale(newLocale)
        queryParams.delete('locale')
        history.replace({
          search: queryParams.toString(),
        })
      }
    }
  })

  return <LandingAerce />
}

export default HomeAerce
